export const description =
  "Remplacer un cumulus par un chauffe-eau thermodynamique (COP ≥ 2,5) divise par 2 ou 3 la consommation d'ECS. Aides cumulables MaPrimeRénov’ + Prime CEE + éco-PTZ + TVA 5,5 %.";
